import { render, staticRenderFns } from "./CompareItem.vue?vue&type=template&id=119d5b7f&scoped=true&"
import script from "./CompareItem.vue?vue&type=script&lang=js&"
export * from "./CompareItem.vue?vue&type=script&lang=js&"
import style0 from "./CompareItem.vue?vue&type=style&index=0&id=119d5b7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119d5b7f",
  null
  
)

export default component.exports